import broadcastService from './broadcast.service';
import eventService from './event.service';

export default angular
  .module('st.Core.Event', [])
  .service('broadcastService', broadcastService)
  .service('eventService', eventService);
